import { render, staticRenderFns } from "./SupportedCurrency.vue?vue&type=template&id=50f39d47&"
import script from "./SupportedCurrency.vue?vue&type=script&lang=js&"
export * from "./SupportedCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports